<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/joborder')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Create JobOrder</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['JobOrder/fetchJobOrders']({ page: this.page });
              $router.push('/joborder');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-select
            v-model="createFields.category"
            :items="categories"
            item-text="name"
            item-value="name"
            label="Item Category*"
            name="category"
            :rules="validationRules.category"
            :error-messages="inputErrorMessages('category')"
          ></v-select>

          <v-select
            :rules="validationRules.product_type_id"
            v-model="createFields.product_type_id"
            :items="productTypes"
            item-text="name"
            item-value="id"
            label="Product Type*"
            name="product_type_id"
            :error-messages="inputErrorMessages('product_type_id')"
          ></v-select>

          <v-select
            :rules="validationRules.customer_id"
            v-model="createFields.customer_id"
            :items="customers"
            item-text="name"
            item-value="id"
            label="Customer*"
            name="customer_id"
            :error-messages="inputErrorMessages('customer_id')"
          ></v-select>
          <v-switch v-model="JobOrderCreateCustomer" inset flat label="Add customer"></v-switch>
          <v-text-field
            v-if="JobOrderCreateCustomer"
            v-model="newCustomerName"
            label="New customer name"
            name="new_customer_name"
            :error-messages="inputErrorMessages('new_customer_name')"
          ></v-text-field>
          <v-text-field
            v-if="JobOrderCreateCustomer"
            v-model="newCustomerContact"
            label="New customer contact"
            name="new_customer_contact"
            :error-messages="inputErrorMessages('new_customer_contact')"
          ></v-text-field>
          <v-btn v-if="JobOrderCreateCustomer" color="blue darken-1" @click="saveCustomer"
            >Save new customer</v-btn
          >
          <v-select
            v-model="createFields.karat"
            :items="karats"
            item-text="name"
            item-value="name"
            label="Karat of Gold"
            name="karat"
            :rules="validationRules.karat"
            :error-messages="inputErrorMessages('karat')"
          ></v-select>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.engraving"
            v-model="createFields.engraving"
            label="Engraving"
            name="engraving"
            :error-messages="inputErrorMessages('engraving')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple_name1"
            v-model="createFields.couple_name1"
            label="Groom"
            name="couple_name1"
            :error-messages="inputErrorMessages('couple_name1')"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.size"
            v-model="createFields.size"
            :label="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
                ? 'Groom Size/s'
                : 'Size/s'
            "
            name="size"
            :error-messages="inputErrorMessages('size')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.width"
            v-model="createFields.width"
            label="Groom Width"
            name="width"
            :error-messages="inputErrorMessages('width')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.thickness"
            v-model="createFields.thickness"
            label="Groom Thickness"
            name="thickness"
            :error-messages="inputErrorMessages('thickness')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.weight"
            v-model="createFields.weight"
            label="Groom Weight of Gold"
            name="weight"
            :error-messages="inputErrorMessages('weight')"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.color"
            v-model="createFields.color"
            :label="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
                ? 'Groom Color of Gold'
                : 'Color of Gold'
            "
            name="color"
            :error-messages="inputErrorMessages('color')"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.no_of_diamond"
            v-model="createFields.no_of_diamond"
            :label="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
                ? 'Groom No. and Size of Diamonds'
                : 'No. and Size of Diamonds'
            "
            name="no_of_diamond"
            :error-messages="inputErrorMessages('no_of_diamond')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple_name2"
            v-model="createFields.couple_name2"
            label="Bride"
            name="couple_name2"
            :error-messages="inputErrorMessages('couple_name2')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple2_size"
            v-model="createFields.couple2_size"
            label="Bride Size"
            name="couple2_size"
            :error-messages="inputErrorMessages('couple2_size')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple2_width"
            v-model="createFields.couple2_width"
            label="Bride Width"
            name="couple2_width"
            :error-messages="inputErrorMessages('couple2_width')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple2_thickness"
            v-model="createFields.couple2_thickness"
            label="Bride Thickness"
            name="couple2_thickness"
            :error-messages="inputErrorMessages('couple2_thickness')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.couple2_weight"
            v-model="createFields.couple2_weight"
            label="Bride Weight of Gold"
            name="couple2_weight"
            :error-messages="inputErrorMessages('couple2_weight')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.color"
            v-model="createFields.couple2_color"
            label="Bride Color of Gold"
            name="couple2_color"
            :error-messages="inputErrorMessages('couple2_color')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.no_of_diamond"
            v-model="createFields.couple2_no_of_diamond"
            label="Bride No. and Size of Diamonds"
            name="couple2_no_of_diamond"
            :error-messages="inputErrorMessages('couple2_no_of_diamond')"
          ></v-text-field>

          <v-text-field
            v-if="
              createFields.category == 'Engagement rings' ||
                createFields.category == 'Engagement Rings' ||
                createFields.category == 'Pendants, earrings, and other accessories' ||
                createFields.category == 'Pendants, Earrings, and Other Accessories'
            "
            :rules="validationRules.gia"
            v-model="createFields.gia"
            label="GIA Code"
            name="gia"
            :error-messages="inputErrorMessages('gia')"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.price"
            v-model="createFields.price"
            label="Price*"
            name="price"
            :error-messages="inputErrorMessages('price')"
            @change="changeReceivable()"
          ></v-text-field>

          <v-text-field
            :rules="validationRules.cogs"
            v-model="createFields.cogs"
            label="Cost of Goods Sold"
            name="cogs"
            :error-messages="inputErrorMessages('cogs')"
          ></v-text-field>

          <v-file-input
            chips
            multiple
            label="Upload sketches/illustration"
            v-model="createFields.files"
            name="files[]"
            :error-messages="inputErrorMessages('files')"
          ></v-file-input>

          <v-text-field
            :rules="validationRules.deposit"
            v-model="createFields.deposit"
            label="Amount Down Payment"
            name="deposit"
            :error-messages="inputErrorMessages('deposit')"
            @change="changeReceivable()"
          ></v-text-field>

          <v-text-field
            :disabled="true"
            :rules="validationRules.balance"
            v-model="createFields.balance"
            label="Amount Receivable/Balance"
            name="balance"
            :error-messages="inputErrorMessages('balance')"
          ></v-text-field>

          <v-menu
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            v-model="weddingDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="weddingDateText"
                label="Wedding Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="weddingDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            v-model="factoryDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="factoryDateText"
                label="Date Delivered from Factory"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="factoryDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="orderDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="orderDateText"
                label="Date of Order"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="orderDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="deliveryDatePicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="deliveryDateText"
                label="Date picked up/purchased by customer"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="deliveryDate"></v-date-picker>
          </v-menu>

          <v-menu
            v-model="deliveryPicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="deliveryText"
                label="Pick up Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="delivery"></v-date-picker>
          </v-menu>

          <v-select
            v-if="
              createFields.category == 'Wedding rings' || createFields.category == 'Wedding Rings'
            "
            :rules="validationRules.rush"
            v-model="createFields.rush"
            :items="rush"
            item-text="name"
            item-value="name"
            label="Rush Order"
            name="rush"
            :error-messages="inputErrorMessages('rush')"
          ></v-select>

          <v-textarea
            v-model="createFields.notes"
            label="Notes"
            counter="255"
            name="notes"
          ></v-textarea>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/joborder');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveJobOrder">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      JobOrderCreateCustomer: false,
      newCustomerName: '',
      newCustomerContact: '',
      orderDatePicker: false,
      deliveryDatePicker: false,
      deliveryPicker: false,
      weddingDatePicker: false,
      factoryDatePicker: false,
      orderDate: '',
      deliveryDate: '',
      delivery: '',
      weddingDate: '',
      factoryDate: '',
      continousCreation: false,
      createValid: true,
      validationRules: {
        category: [v => !!v || this.rem('Item Category')],
        customer_id: [v => !!v || this.rem('Customer')],
        price: [
          v => !!v || this.rem('Price'),
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Price should be a number',
          v => v > 0 || 'Price should be greater than 0'
        ],
        deposit: [
          v => (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) || 'Deposit should be a number'
        ],
        product_type_id: [v => !!v || this.rem('Product Type')]
      },
      errorMessages: {},
      createFields: {
        category: '',
        customer_id: undefined,
        couple_name1: '',
        couple_name2: '',
        contact_number: '',
        product_type_id: '',
        size: '',
        width: '',
        thickness: '',
        weight: '',
        karat: '',
        color: '',
        no_of_diamond: '',
        couple2_size: '',
        couple2_width: '',
        couple2_thickness: '',
        couple2_weight: '',
        couple2_color: '',
        couple2_no_of_diamond: '',
        engraving: '',
        gia: '',
        price: 0,
        cogs: '',
        files: undefined,
        deposit: 0,
        balance: 0,
        weddingDate: '',
        factoryDate: '',
        orderDate: '',
        deliveryDate: '',
        delivery: '',
        rush: '',
        notes: ''
      }
    };
  },
  props: {
    create: false,
    page: 0
  },
  computed: {
    ...mapState({
      customers: state => state.Customer.plaincustomers,
      productTypes: state => state.ProductType.plainproductTypes,
      categories: state => state.Category.categories,
      karats: state => state.Karat.karats,
      rush: state => state.Rush.rush
    }),
    orderDateText() {
      return this.orderDate;
    },
    deliveryDateText() {
      return this.deliveryDate;
    },
    deliveryText() {
      return this.delivery;
    },
    weddingDateText() {
      return this.weddingDate;
    },
    factoryDateText() {
      return this.factoryDate;
    }
  },

  mounted() {
    this['Customer/fetchCustomers']({ dontPaginate: false });
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
  },
  methods: {
    ...mapActions([
      'JobOrder/fetchJobOrders',
      'Customer/fetchCustomers',
      'ProductType/fetchProductTypes'
    ]),
    clearCreate() {
      this.createFields = {
        category: '',
        customer_id: undefined,
        couple_name1: '',
        couple_name2: '',
        contact_number: '',
        product_type_id: '',
        size: '',
        width: '',
        thickness: '',
        weight: '',
        karat: '',
        color: '',
        no_of_diamond: '',
        engraving: '',
        gia: '',
        price: 0,
        cogs: '',
        files: undefined,
        deposit: 0,
        balance: 0,
        weddingDate: '',
        factoryDate: '',
        orderDate: '',
        deliveryDate: '',
        delivery: '',
        rush: '',
        notes: ''
        //quantity: 1
      };
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveJobOrder() {
      if (this.$refs.createForm.validate()) {
        const formData = new FormData(this.$refs.createForm.$el);
        formData.append('customer_id', this.createFields.customer_id);
        formData.append('product_type_id', this.createFields.product_type_id);
        formData.append('category', this.createFields.category);
        formData.append('karat', this.createFields.karat);
        formData.append('rush', this.createFields.rush);
        formData.append('weddingDate', this.weddingDate);
        formData.append('factoryDate', this.factoryDate);
        formData.append('orderDate', this.orderDate);
        formData.append('deliveryDate', this.deliveryDate);
        formData.append('delivery', this.delivery);
        console.log(formData);
        axios
          //.post('api/v1/joborder', this.createFields)
          .post('api/v1/joborder', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'JobOrder created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['JobOrder/fetchJobOrders']({ page: this.page });
            this.clearCreate();
            if (this.continousCreation === false) {
              this.$router.push('/joborder');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    },
    changeReceivable() {
      this.createFields.balance =
        parseFloat(this.createFields.price) - parseFloat(this.createFields.deposit);
    },
    saveCustomer() {
      axios
        .post('api/v1/customer', {
          name: this.newCustomerName,
          contact_numbers: this.newCustomerContact
        })
        .then(response => {
          this.errorMessages = [];
          this.createFields.customer_id = response.data.customer.id;
          this.newCustomerName = '';
          this.JobOrderCreateCustomer = false;
          this.new_customer_name = '';
          this.new_customer_contact = '';
        })
        .catch(error => {
          console.log(error.response.data);
          this.$store.commit('SET_SNACK_BAR', {
            message: error.response.data['errors']['name'][0],
            color: 'error'
          });
        })
        .finally(() => {
          this['Customer/fetchCustomers']({ dontPaginate: false });
        });
    }
  }
};
</script>
